<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Promo</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="promo.id === null">New</span>
              <span v-else>
                {{ promo.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="promo.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="discount" class="col-sm-3 col-form-label text-left">Discount</label>
              <div class="col-sm-9">
                <input type="text" v-model="promo.discount" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label for="valid_date" class="col-sm-3 col-form-label text-left">Valid Date</label>
              <div class="col-sm-9">
                <el-date-picker style="width: 100%" v-model="promo.valid_date" type="datetime" placeholder="datetime"></el-date-picker>
              </div>
            </div>
            <div class="form-group row">
              <label for="percentage" class="col-sm-3 col-form-label text-left">Percentage</label>
              <div class="col-sm-9">
                <el-checkbox v-model="promo.percentage" ></el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updatePromo" class="btn btn-sm btn-primary pull-right" v-show="promo.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createPromo" class="btn btn-sm btn-primary pull-right" v-show="promo.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <!-- <pre>
      {{ promo }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { promoUrl, getHeader } from '../../config'

export default {
  name: 'PromoForm',
  props: ['promo'],
  computed: {
    ...mapState({
      //
    })
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updatePromo () {
      axios.put(promoUrl + '/' + this.promo.id, this.promo, { headers: getHeader() })
        .then(response => {
          this.$swal('Promo', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createPromo () {
      axios.post(promoUrl, this.promo, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
